import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Row, Col } from 'react-flexbox-grid'
import isEmpty from 'lodash.isempty'

import { getLifetimeStats } from 'services/userStats/actions'
import { selectSummaryStats, selectStatsWithActivityNames } from 'services/userStats/selectors'
import { selectUserId } from 'services/user/selectors'

import Loader from 'components/util/Loader'
import PageHeader from 'components/util/PageHeader'
import { ExportWorkoutHistory } from 'components/sidebar'
import StatsSummary from './StatsSummary'
import StatsTable from './StatsTable'

import styles from './_lifetimeStats.css'

const mapStateToProps = (state) => ({
  statsByActivity: selectStatsWithActivityNames(state),
  summaryStats: selectSummaryStats(state),
  userId: selectUserId(state),
})

const mapDispatchToActions = { getLifetimeStats, push }

export class LifetimeStatsPage extends Component {

  static propTypes = {
    getLifetimeStats: PropTypes.func.isRequired,
    statsByActivity: PropTypes.array,
    summaryStats: PropTypes.array,
    userId: PropTypes.number,
  }

  state = {
    hasError: false,
  }

  componentWillMount () {
    this.props.getLifetimeStats(this.props.userId)
      .then(() => this.setState({ ...this.state, hasError: false }))
      .catch(() => this.setState({ ...this.state, hasError: true }))
  }

  renderErrorMessage () {
    return (
      <div>
        <FormattedMessage
          id='workouts.lifetimestats.error'
          defaultMessage='There was an error loading your stats. Please refresh to try again.' />
      </div>
    )
  }

  renderSpinner () {
    return (
      <div className={styles.pageLoader}>
        <Loader type='spin' height={60} width={60} />
      </div>
    )
  }

  render () {

    const { statsByActivity, summaryStats } = this.props
    const { hasError } = this.state

    return (
      <div className={styles.lifetimeStatsContainer}>
        <Row>
          <Col xs={12} sm={8}>

            <PageHeader>
              <h1>
                <FormattedMessage id='workouts.lifetimestats.pageheader' defaultMessage='My Lifetime Stats' />
              </h1>
            </PageHeader>

            { (!summaryStats || !statsByActivity) && !hasError ? this.renderSpinner() : null }
            { hasError ? this.renderErrorMessage() : null }

            { summaryStats && !isEmpty(summaryStats) && statsByActivity && !hasError ?
              <div>
                <StatsSummary totals={summaryStats} />
                <StatsTable individualWorkoutStats={statsByActivity} totals={summaryStats} />
              </div>
            : null }

            { summaryStats && isEmpty(summaryStats) && !hasError ?
              <div>
                <FormattedMessage
                  id='workouts.lifetimestats.notfound'
                  defaultMessage={'It looks like you haven\'t recorded any workouts yet.'} />
              </div>
            : null }
          </Col>

          { summaryStats && !isEmpty(summaryStats) ?
            <Col sm={4}>
              <ExportWorkoutHistory />
            </Col>
          : null }

        </Row>
      </div>
    )
  }
}

export const Page = injectIntl(LifetimeStatsPage)
export default connect(mapStateToProps, mapDispatchToActions)(Page)



// WEBPACK FOOTER //
// ./src/components/workouts/dashboard/lifetime/LifetimeStatsPage.jsx